import { DetalleBoletaHonorarios } from "./DetalleBoletaHonorarios";

export class BoletaHonorariosEmitida {
	boletaHonorarioId: string;
	retencionPorEmisor: boolean;
	terceros: boolean;
	personaAutorizada: string;
	nombrePersonaAutorizada: string;
	rutPersonaAutorizada: string;
	direccionEmisor: string;
	direccionCodigoEmisor: number;
	comunaEmisor: string;
	fechaEmision: Date;
	rutReceptor: number;
	dvReceptor: string;
	rutEmisor: number;
	dvEmisor: string;
	rutStringReceptor: string;
	nombreReceptor: string;
	direccionReceptor: string;
	regionReceptor: string;
	regionCodigoReceptor: number;
	comunaReceptor: string;
	bruto: number;
	retencionEmisor: number;
	retencionReceptor: number;
	liquido: number;
	retenido: number;
	pagado: number;
	total: number;
	anulada: boolean;
	descripcionAnulacion: string;
	estado: string;
	codigoBarra: string;
	pdf: string;
	usuarioId: string;
	emisorId: string;
	detalles: DetalleBoletaHonorarios[];
	folio: number;
	importada: boolean;
}
